module.exports = __webpack_public_path__ + "static/media/pic2.d098544a.jpg";